import { useMemo } from 'react';

export default function useConditionalClassname(condition, baseClassName, additionalClassName) {
  return useMemo(() => {
    if (condition) {
      return `${baseClassName} ${additionalClassName}`;
    }

    return baseClassName;
  }, [condition, baseClassName, additionalClassName]);
}
